/**
 * List of supported locales.
 * Should equal to `projectLang` in .adsk/ContinuousLocalization.yml
 *
 * @type {string[]}
 */
export const supportedLocales = [
  'en',
  'de',
  'fr',
  'en-GB',
  'es',
  'pt-BR',
  'ja',
  'zh-Hans',
  'zh-Hant-HK',
  'nl',
  'sv',
  'da',
  'fr-CA',
  'it',
  'ko',
  'ru',
  'pl',
  'cs',
  'zh-Hant',
  'no',
];
